module.exports = __webpack_public_path__ + "img/contagem_e_classificacao.740b79e7.png";